<rt-provider-item
  [status]="signedIn() ? 'connected' : 'inactive'"
  [headerTpl]="headerTpl"
  [initials]="companyName()[0]"
  [description]="isOwner() ? ('tlc.members.isOwnerBadge' | translate) : null"
>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</rt-provider-item>

<ng-template #headerTpl>
  <rt-heading
    ><rt-truncate>{{ companyName() }}</rt-truncate></rt-heading
  >
</ng-template>

<ng-template #content>
  <rt-group layout-justify-flex-end layout-align-items-center class="sign-button-group">
    @if (signedIn()) {
      <div class="active" layout layout-align-items-center text-primary text-bold>
        <rt-icon name="check" margin-right-small-x colorToken="colorIconPrimaryDefault"></rt-icon>
        {{ 'tlc.current_user.companies.company_item.label' | translate }}
      </div>
    } @else {
      <div>
        <rt-button (click)="signIn.emit()" variant="outline">{{
          'tlc.current_user.companies.company_item.button' | translate
        }}</rt-button>
      </div>
    }

    <rt-icon-button
      (click)="moreDropdown.open = !moreDropdown.open"
      rt-overlay-origin
      #moreDropdownTrigger="rtOverlayOrigin"
      variant="plain"
      [pressed]="moreDropdown.open"
      shape="square"
      iconName="more-horiz"
      margin-left-small
    >
    </rt-icon-button>
  </rt-group>

  <ng-template
    #moreDropdown="rtConnectedOverlay"
    (backdropClick)="moreDropdown.open = false"
    [origin]="moreDropdownTrigger"
    rt-connected-overlay
    hasBackdrop
  >
    <rt-dropdown [width]="DropdownWidth.SmallX">
      <rt-dropdown-item (click)="leaveCompany.emit()">
        <rt-icon prefix name="remove-circle"></rt-icon>
        {{ 'tlc.current_user.companies.company_item.dropdown_item' | translate }}
      </rt-dropdown-item>
    </rt-dropdown>
  </ng-template>
</ng-template>
